import React from 'react';
import { Img } from './styles';
import StarIcon from '../../../assets/icons/star.svg';

const Star = ({ key, style }) => <Img src={StarIcon} key={key} alt="star icon" />;

export default Star;
